import React, { useEffect } from "react";
import { useGetImage } from "utils/apis/lookups.api";

export default function ImagePreview({ path }: { path: string }) {
  const { data: response, mutate: getImage } = useGetImage();

  useEffect(() => {
    if (path) {
      getImage(path);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  return (
    <img
      src={response ? URL.createObjectURL(response as Blob) : ""}
      alt="Preview"
    />
  );
}
